import { render, staticRenderFns } from "./new-user-form.vue?vue&type=template&id=3ce0a5b9&scoped=true&"
import script from "./new-user-form.vue?vue&type=script&lang=js&"
export * from "./new-user-form.vue?vue&type=script&lang=js&"
import style0 from "./new-user-form.vue?vue&type=style&index=0&id=3ce0a5b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce0a5b9",
  null
  
)

export default component.exports